import React from "react";
import { Phone } from "lucide-react";

export const StickyCallButton = () => (
  <a
    href="tel:+33620735220"
    data-testid="sticky-call-button"
    className="lg:hidden fixed bottom-5 right-5 z-40 flex items-center gap-2 bg-[#FFD600] hover:bg-[#FACC15] text-[#0A0A0A] font-bold px-5 py-4 rounded-full shadow-2xl glow-yellow"
    aria-label="Appeler MK Remorquage"
  >
    <Phone className="w-5 h-5" strokeWidth={3} />
    <span className="text-sm uppercase tracking-wide">Appeler</span>
  </a>
);

export default StickyCallButton;
